import utils from '../utils';

// function startPauseCursor(cursor, video) {
// 	var cursorH = cursor.offsetHeight / 2,
// 		cursorW = cursor.offsetWidth / 2;
// 	video.addEventListener('mousemove', function (e) {
// 		var mousepos = {
// 			x: e.clientX / 2 - cursorH,
// 			y: e.clientY / 2 - cursorW
// 		};
// 		cursor.style.transform = 'translate3d(' + mousepos.x + 'px,' + mousepos.y + 'px,0)';
// 	});
// }

function startVideo(videoWrapper) {

	var video = videoWrapper.querySelector('video'),
		button = videoWrapper.querySelector('button');
	video.setAttribute('data-play', 'false');

	button.addEventListener('click', function () {
		if (video.getAttribute('data-play') === 'false') {
			video.play();
			video.setAttribute('data-play', 'true');
			videoWrapper.classList.add('is-playing');
			setTimeout(function () {
				videoWrapper.classList.add('pause-icon');
				//startPauseCursor(button, video);
			}, 800);
		}
	});

	video.addEventListener('click', function () {
		if (video.getAttribute('data-play') === 'true') {
			video.pause();
			video.setAttribute('data-play', 'false');
			videoWrapper.classList.remove('is-playing');
			videoWrapper.classList.remove('pause-icon');

		}
	});

}

function init() {
	var videoWrapper = document.querySelectorAll('.video-wrapper');
	if (videoWrapper.length > 0) {
		utils.forEach(videoWrapper, function (index, elem) {
			startVideo(elem);
		});
	}
}

export default {
	init,
};